import {FC} from 'react';
import {useParams} from 'react-router';
import {api, useT} from '@kcast-fe/core';
import {Box, Center} from '@chakra-ui/react';
import {Modal, Loader} from 'ui-kit';

import {EmptyRecordsInfo, MsgInspector} from './components';

const MAX_WIDTH = {base: '1024px', smToMd: 'calc(100% - 12px)'};

export const MsgInspectorScene: FC = () => {
  const {msgId} = useParams();

  const {data, isLoading} = api.promptRecords.useMessageRecordsByIdQuery(msgId ?? '');

  const {t} = useT();

  return (
    <Modal isOpen isFullHeight title={t('actions.contextInspector')} maxW={MAX_WIDTH}>
      <Box p={'16px 0 32px 0'} h={'full'} overflow={'hidden'}>
        <Center h={'full'}>
          {isLoading ? (
            <Loader size={'lg'} />
          ) : !data || !data.found || (data.records?.length ?? 0) === 0 ? (
            <EmptyRecordsInfo />
          ) : (
            <MsgInspector records={data.records} />
          )}
        </Center>
      </Box>
    </Modal>
  );
};
